module.exports = __webpack_public_path__ + "img/menu_03.6831e19.svg";